<template>
  <table>
    <tbody>
      <tr>
        <td class="bg-fade-primary-8 display-5 shadow p-2">
          Origin
        </td>
        <td class="bg-fade-primary-8 display-5 shadow p-2">
          Flight
        </td>
        <td class="bg-fade-primary-8 display-5 shadow p-2">
          Departure
        </td>
        <td class="bg-fade-primary-8 display-5 shadow p-2">
          Arrival
        </td>
        <td class="bg-fade-primary-8 display-5 shadow p-2">
          Status
        </td>
      </tr>
      <tr
        v-for="(flight, index) in flights"
        :key="'flight' + index"
      >
        <td class="bg-fade-primary-dark-8 display-5 shadow p-2">
          {{ flight.origin }}
        </td>
        <td class="bg-fade-primary-dark-8 display-5 shadow p-2">
          {{ flight.flight }}
        </td>
        <td class="bg-fade-primary-dark-8 display-5 shadow p-2">
          {{ flight.departure }}
        </td>
        <td class="bg-fade-primary-dark-8 display-5 shadow p-2">
          {{ flight.arrival }}
        </td>
        <td class="bg-fade-primary-dark-8 display-5 shadow p-2">
          {{ flight.status }}
        </td>
      </tr>
      <tr
        v-for="n in getRange"
        :key="n"
      >
        <td class="bg-fade-primary-dark-8 display-5 shadow p-2">
          &nbsp;
        </td>
        <td class="bg-fade-primary-dark-8 display-5 shadow p-2" />
        <td class="bg-fade-primary-dark-8 display-5 shadow p-2" />
        <td class="bg-fade-primary-dark-8 display-5 shadow p-2" />
        <td
          v-if="n === getRange"
          class="bg-fade-primary-dark-8 shadow p-2"
        >
          {{ lastUpdate }}
        </td>
        <td
          v-else
          class="bg-fade-primary-dark-8 display-5 shadow p-2"
        />
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  name: 'ArrivalTable',
  props: {
    flights: {
      type: Array,
      required: true,
    },
    lastUpdate: {
      type: String,
      required: true,
    },
  },
  computed: {
    getRange() {
      if (this.flights.length > 5) {
        return 0;
      }
      return 5 - this.flights.length;
    },
  },
};
</script>
